import { AppRoutes } from '@bn/dashboard-core/enums';
import { MenuItem } from '@bn/layout';
import { ORIGIN_PATHS } from '../../../pages/origin-error/static-data';

export enum DashboardMenuSection {
  Overview = 'Overview',
  Delivery = 'Delivery',
  EdgePlatform = 'Edge Platform',
  Monitoring = 'Monitoring',
  Internal = 'Internal',
  Logout = 'Logout',
}

export const mainMenuConfig: () => MenuItem[] = () => [
  {
    name: DashboardMenuSection.Overview,
    icon: ['fad', 'house-blank'],
    route: AppRoutes.Overview,
    isIndependentRootItem: true,
  },
  {
    name: DashboardMenuSection.Delivery,
    isOpen: true,
    roleIds: ['SubuserManage'],
    children: [
      {
        name: 'CDN',
        icon: ['fad', 'location-dot'],
        route: AppRoutes.CDN,
      },
      {
        name: 'Storage',
        icon: ['fad', 'hard-drive'],
        route: AppRoutes.Storage,
      },
      {
        name: 'Stream',
        icon: ['fad', 'circle-play'],
        route: AppRoutes.Stream,
      },
      {
        name: 'DNS',
        icon: ['fad', 'sign-hanging'],
        route: AppRoutes.DNS,
      },
      {
        name: 'Purge',
        icon: ['fad', 'trash-can'],
        route: AppRoutes.Purge,
      },
    ],
  },
  {
    name: DashboardMenuSection.EdgePlatform,
    isOpen: true,
    roleIds: ['SubuserManage'],
    children: [
      {
        name: 'Magic Containers',
        icon: ['fad', 'wand-magic-sparkles'],
        route: AppRoutes.MagicContainers,
      },
      {
        name: 'Scripting',
        icon: ['fad', 'code'],
        route: AppRoutes.Script,
      },
      {
        name: 'Database',
        icon: ['fad', 'database'],
        route: AppRoutes.Database,
      },
    ],
  },
  {
    name: 'AI',
    isOpen: true,
    roleIds: ['SubuserManage'],
    children: [
      {
        name: 'AI Gateway',
        icon: ['fad', 'microchip-ai'],
        route: AppRoutes.AIGateway,
        featureFlag: 'ai-gateway',
      },
    ],
  },
  {
    name: DashboardMenuSection.Monitoring,
    roleIds: ['SubuserManage'],
    children: [
      {
        name: 'Statistics',
        icon: ['fad', 'chart-simple'],
        route: AppRoutes.Statistics,
      },
      {
        name: 'Logs',
        icon: ['fad', 'align-left'],
        route: AppRoutes.Logs,
      },
      {
        name: 'Origin Errors',
        icon: ['fad', 'cloud-exclamation'],
        route: ORIGIN_PATHS.base,
      },
    ],
  },
  {
    name: DashboardMenuSection.Internal,
    roleIds: ['Agent'],
    children: [
      {
        name: 'Surveys',
        icon: ['fad', 'microchip-ai'],
        route: AppRoutes.Surveys,
        featureFlag: 'surveys',
      },
    ],
  },
  {
    name: DashboardMenuSection.Logout,
    route: AppRoutes.Logout,
    class: 'd-block d-lg-none',
    isFaded: true,
    isIndependentRootItem: true,
  },
];

export const mainMenuChildRoutes: () => Record<string, string> = () =>
  Object.fromEntries(
    mainMenuConfig().flatMap((item) => [
      ...(item.children?.map((child) => [child.route, item.name]) ?? []),
      ...(item.route ? [[item.route ?? '/', item.name ?? DashboardMenuSection.Delivery]] : []),
    ]),
  );
